import { PlayerRef } from '@remotion/player';
import React, { useEffect } from 'react';
import { isEventTargetInputElement } from './is-event-target-input-element';
import { useCurrentStateAsRef } from './use-context';
import { FEATURE_ARROW_KEY_MOVE } from '../flags';
import { getSelectionArrowAction } from '@waka/compat/selection-arrow-action';

export const useKeyboardControls = ({
  playerRef,
  fps,
}: {
  playerRef: React.RefObject<PlayerRef | null>;
  fps: number;
}) => {
  const stateRef = useCurrentStateAsRef();
  useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      if (isEventTargetInputElement(e) || e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      // Registration order must not let seeking steal a selected-clip nudge.
      if (
        FEATURE_ARROW_KEY_MOVE &&
        getSelectionArrowAction(stateRef.current, e.key, e.altKey)
      )
        return;
      const current = playerRef.current;
      if (!current) return;

      const moveBy = e.shiftKey ? fps : 1;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        current.seekTo(current.getCurrentFrame() + moveBy);
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        current.seekTo(current.getCurrentFrame() - moveBy);
      }
    };

    window.addEventListener('keydown', onKeydown);

    return () => {
      window.removeEventListener('keydown', onKeydown);
    };
  }, [fps, playerRef, stateRef]);
};
